<template>
  <div class="transfer_p">
    <div class="transfer_p1 btm_margin" v-if="authjson.authjson(['11-7'])">
      <div class="p2">&nbsp;</div>
      <div class="btn_box_mobile">
        <el-button
          class="p3 border_set_color2"
          size="medium"
          @click="$router.push('/blockchain_w/m_m_addr_list')"
        >
          <img
            class="user_icon"
            src="../../../assets/img/ball_icon.png"
            alt=""
          />
          {{ $t("main.text370") }}
        </el-button>
      </div>
    </div>
    <div class="p4" v-if="authjson.authjson(['11-8'])">
      <div class="p4_top">
        <div class="p4_top1">{{ $t("main.text462") }}</div>
        <div class="p4_top2">{{ $t("main.text463") }}</div>
      </div>
      <div class="p4_main_box">
        <div class="p4_main">
          <div class="p4_main1">
            <el-form label-position="top" class="zdy_form">
              <el-form-item
                style="width: 100%"
                :label="checked_jmhb ? $t('main.text460') : $t('main.text464')"
              >
                <div class="zdy_input">
                  <el-input
                    v-model="input_v3_set"
                    placeholder=""
                    @input="input3_set"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d{8}).*$/, '$1$2.$3').replace(/^\./g, '')"
                  ></el-input>
                  <!-- 加密货币 -->
                  <el-popover
                    width="170"
                    popper-class="bz_pop"
                    v-model="visible3"
                    trigger="click"
                  >
                    <div slot="reference" class="type_box">
                      <div class="type_box1">
                        <img :src="set_name_img(select3)" alt="" />
                        <div class="type_box2">{{ select3 }}</div>
                      </div>
                      <div class="type_box3">
                        <i class="el-icon-caret-bottom"></i>
                      </div>
                    </div>
                    <div class="bz_list">
                      <div
                        class="type_box1 bz_list1"
                        v-for="(item, index) in currency_list3"
                        :key="index"
                        @click="select3_fun(item)"
                      >
                        <img :src="set_name_img(item)" alt="" />
                        <div class="type_box2">{{ item }}</div>
                      </div>
                    </div>
                  </el-popover>
                </div>
                <div class="inp_btm_tit">
                  {{ $t("main.text459") }}{{ select3 }} =
                  {{ set_num3(inp3_ratio.balance) }}
                </div>
                <div class="inp_btm_tit2">
                  {{ $t("main.text732") }}
                  {{ fee_obj.rate * 100 }}%
                  {{ $t("main.text733") }}
                  {{ fee_obj.fee }} {{ select3 }}
                  {{ $t("main.text734") }}
                </div>
                <div>
                  <div v-show="select3 == 'USDT' || select3 == 'USDC'">
                    <span
                      class="b_type"
                      :class="act_index == 1 ? 'b_type_act' : ''"
                      @click="act_index_fun(1)"
                      >ERC20</span
                    >
                    <span
                      v-if="select3 == 'USDT'"
                      class="b_type"
                      :class="act_index == 2 ? 'b_type_act' : ''"
                      @click="act_index_fun(2)"
                      >TRC20</span
                    >

                    <span
                      class="b_type"
                      :class="act_index == 3 ? 'b_type_act' : ''"
                      @click="act_index_fun(3)"
                      >BEP20</span
                    >

                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-button
          class="bz_btn"
          @click="Continue_encryption_btn"
          :disabled="is_dab"
          >{{ $t("main.text394") }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <div class="transaction_h" v-if="authjson.authjson(['11-9'])">
      <div class="t_h1">
        <div class="t_h1_top">{{ $t("main.text322") }}</div>
        <div class="t_h1_box">
          <el-form
            class="zdy_form"
            label-position="top"
            label-width="300px"
            :model="form"
          >
            <el-form-item :label="$t('main.text99')" class="riqi_box">
              <el-date-picker
                popper-class="time_box"
                :clearable="false"
                :editable="false"
                v-model="form.time"
                type="daterange"
                :format="v_lan == 'en' ? 'dd/MM/yyyy' : 'yyyy/MM/dd'"
                value-format="yyyy-MM-dd"
                range-separator="-"
                :start-placeholder="$t('main.text324')"
                :end-placeholder="$t('main.text325')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('main.text282')">
              <el-select
                v-model="form.token_type"
                :placeholder="$t('main.text344')"
              >
                <el-option label="BTC" value="BTC"></el-option>
                <el-option label="ETH" value="ETH"></el-option>
                <el-option label="USDT" value="USDT"></el-option>
                <el-option label="USDC" value="USDC"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('main.text326')">
              <el-input v-model="form.amount" placeholder=""></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text316')">
              <el-select
                v-model="form.status"
                :placeholder="$t('main.text344')"
              >
                <!-- 状态: 20 成功 21 审核中 22 审核失败; 23 交易中 ；24 交易失败 ； -->
                <el-option :label="$t('main.text317')" value="20"></el-option>
                <el-option :label="$t('main.text318')" value="21"></el-option>
                <el-option :label="$t('main.text319')" value="22"></el-option>
                <el-option :label="$t('main.text320')" value="23"></el-option>
                <el-option :label="$t('main.text321')" value="24"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form>
            <el-form-item class="btn_box">
              <el-button
                class="reset_btn border_set_color"
                size="medium"
                @click="reset_btn"
                >{{ $t("main.text329") }}</el-button
              >
              <el-button class="apply_btn" size="medium" @click="apply_btn">{{
                $t("main.text330")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="t_h2">
        <div class="t_h2_box">
          <div>
            <div class="t_h2_txt1">{{ $t("main.text346") }}</div>
          </div>
          <div>
            <el-button v-if="authjson.authjson(['11-10'])"
              class="export_btn border_set_color2"
              icon="el-icon-download"
              size="medium"
              @click="download_btn"
              >{{ $t("main.text333") }}</el-button
            >
          </div>
        </div>
        <div class="t_h2_table zdy_tab_header">
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column :label="$t('main.text99')" min-width="120">
              <span slot-scope="props">
                {{ overall_time(props.row.c_time) }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text751')" min-width="120">
              <span slot-scope="props">
                <span v-html="props.row.type_name"></span>
                <!-- type 3,4,5,6,7,8,12 卡号 -->
                <!-- type 2,10,11 显示name -->
                <!-- type 1,9,13 remark -->
                <div v-if="[3, 4, 5, 6, 7, 8, 12].includes(props.row.type)">
                  <p>{{ $t("main.text767") }} {{ props.row.card_number }}</p>
                </div>
                <div v-else-if="[2, 10, 11].includes(props.row.type)">
                  {{ props.row.name }}
                </div>
                <div>
                  {{ props.row.remark }}
                </div>
              </span>
            </el-table-column>

            <el-table-column prop="tx_id" :label="$t('main.text326')" min-width="120">
            </el-table-column>

            <el-table-column :label="$t('main.text769')" min-width="120">
              <span slot-scope="props">
                <span>
                  {{ set_num3_2(props.row.amount) }}
                </span>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text316')" min-width="120">
              <span slot-scope="props">
                <!-- 状态: 20 成功 21 审核中 22 审核失败; 23交易中；24交易失败 25 待审核 -->
                <span v-if="props.row.status == 20">{{
                  $t("main.text317")
                }}</span>
                <span v-else-if="props.row.status == 21">{{
                  $t("main.text318")
                }}</span>
                <span v-else-if="props.row.status == 22">{{
                  $t("main.text319")
                }}</span>
                <span v-else-if="props.row.status == 23">{{
                  $t("main.text320")
                }}</span>
                <span v-else-if="props.row.status == 24" class="color_red">{{
                  $t("main.text321")
                }}</span>
                <span v-else-if="props.row.status == 25">{{
                  $t("main.text229")
                }}</span>
                <span v-else>-</span>
              </span>
            </el-table-column>

            <el-table-column width="80">
              <span slot-scope="props">
                <img
                  @click="
                    to_info(props.row.tx_id, props.row.id, props.row.tx_type)
                  "
                  class="icon_width"
                  src="../../../assets/img/info_icon.png"
                  alt=""
                />
              </span>
            </el-table-column>
          </el-table>

          <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="page_total"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- ---- -->
  </div>
</template>

<script>
import { withdraw_details, crypto_calc } from "@/api/api";
import { crypto_record, crypto_download } from "@/api/api";
import BigNumber from "bignumber.js";
import { debounce } from "@/utils/util.js";

export default {
  data() {
    return {
      checked: false,
      checked_jmhb: false,

      interval_name: null,
      djs_num: 60 * 5,
      djs_text: "05:00",
      time_dlg: false,

      visible1: false,
      select1: "",
      input_v1: "",
      input_v1_set: "",
      inp1_ratio: "",

      visible2: false,
      select2: "",
      input_v2: "",
      inp2_ratio: "",

      visible3: false,
      select3: "USDT",
      input_v3: "",
      input_v3_set: "",
      inp3_ratio: "",

      visible4: false,
      select4: "USD",
      input_v4: "",
      inp4_ratio: "",
      currency_list4: ["USD", "SGD", "GBP", "AUD", "HKD", "CNY"],

      data_all: {},
      currency_list: ["USD", "SGD", "CNY"],
      currency_list2: [],
      currency_list3: ["USDT", "USDC"],
      f_api_data: {},
      // 币种 图标
      icon_list: {
        ETH: require("../../../assets/img/ETH.png"),
        USDT: require("../../../assets/img/USDT.png"),
        BTC: require("../../../assets/img/BTC.png"),
        USDC: require("../../../assets/img/USDC.png"),
        USD: require("../../../assets/img/GBP.png"),
        CNY: require("../../../assets/img/CNY.png"),
        SGD: require("../../../assets/img/SGD.png"),
        GBP: require("../../../assets/img/USD.png"),
        AUD: require("../../../assets/img/AUD.png"),
        HKD: require("../../../assets/img/HKD.png"),
      },
      audit_usd_amount: 0,
      act_index: 1,
      api_data_obj: {
        value: "",
      },
      fee_obj: {
        fee: "",
        rate: "",
      },
      is_dab: true,
      fixed_fee: 0,
      processing_fee: 0,
      processing_rate: 0,
      total_amount: 0,

      // 表格
      form: {
        time: "",
        token_type: "",
        amount: "",
        status: "",
      },
      currentPage: 1,
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      page_total: 0, //一共多少条
      tableData: [],
      // ----
    };
  },
  mounted() {
    sessionStorage.setItem("top_title_name", this.$t("main.text15"));
    this.select1 = this.currency_list[0];
    this.set_list2();
    this.get_list();
    this.get_list_table();
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  methods: {
    get_list() {
      withdraw_details().then((res) => {
        if (res.data.code == 200) {
          this.data_all = res.data.data;

          if (this.data_all[this.set_api_key(this.select1)]) {
            this.inp1_ratio = this.data_all[this.set_api_key(this.select1)]; //1 默认的数据
          }

          if (this.data_all[this.set_api_key(this.select2)]) {
            this.inp2_ratio = this.data_all[this.set_api_key(this.select2)]; //2 默认的数据
          }

          if (this.data_all[this.set_api_key(this.select3)]) {
            this.inp3_ratio = this.data_all[this.set_api_key(this.select3)]; //3 默认的数据
            // 加密货币 是否审核 提示文字  <= 200
            this.audit_usd_amount =
              this.data_all[this.set_api_key(this.select3)].audit_usd_amount;
          }

          if (this.data_all[this.set_api_key(this.select4)]) {
            this.inp4_ratio = this.data_all[this.set_api_key(this.select4)];
          }
          this.set_fee();
        }
      });
    },
    // 设置key 对应接口 key
    set_api_key(v) {
      if (v.indexOf("-") != -1) {
        return v.toLowerCase().replace("-", "_");
      } else {
        return v.toLowerCase();
      }
    },
    set_name_img(v) {
      if (v.indexOf("-") != -1) {
        let str1 = v.split("-")[0];
        return this.icon_list[str1];
      } else {
        return this.icon_list[v];
      }
    },
    set_list2() {
      if (this.select1) {
        this.currency_list2 = this.currency_list.filter(
          (item) => item != this.select1
        );
        this.select2 = this.currency_list2[0];
      }
    },
    select1_fun(v) {
      this.select1 = v;
      this.visible1 = false;
      this.inp1_ratio = this.data_all[this.set_api_key(v)];
      
      this.set_list2();
      this.checked_active();
    },
    select2_fun(v) {
      this.select2 = v;
      this.visible2 = false;
      this.inp2_ratio = this.data_all[this.set_api_key(v)];
      this.checked_active();
    },
    select3_fun(v) {
      this.select3 = v;
      this.visible3 = false;
      this.inp3_ratio = this.data_all[this.set_api_key(v)];

      this.audit_usd_amount =
        this.data_all[this.set_api_key(v)].audit_usd_amount;
      this.act_index = 1;

      this.input_v3 && this.Continue_other_btn();
      this.set_fee();
    },
    select4_fun(v) {
      this.select4 = v;
      this.visible4 = false;
      this.inp4_ratio = this.data_all[this.set_api_key(v)];
      this.Continue_other_btn();
    },
    input1_set(v) {
      v;
      this.input_v1 = v;
      this.input_v1_set = this.set_num3_2(v);
      this.checked_active();
    },
    input2_set(v) {
      v;
    },
    input3_set(v) {
      this.input_v3 = v;
      this.input_v3_set = this.set_num3_2(v);
      this.input_v3 && this.Continue_other_btn();
    },
    // 加密货币 提币按钮
    Continue_encryption_btn() {
      // 余额为0 或者 余额小于 最小提币数量
      if (this.inp3_ratio.balance * 1 <= 0) {
        return this.message.ismessage("error", this.$t("main.text468"));
      }

      if (!this.input_v3) {
        return this.message.ismessage("error", this.$t("main.text469"));
      }

      if (
        (this.select3 == "USDT" || this.select3 == "USDC") &&
        (this.act_index == "" || this.act_index == 0)
      ) {
        return this.message.ismessage("error", this.$t("main.text483"));
      }

      // 不转换 以前的逻辑
      if (!this.checked_jmhb) {
        let u_token_type = "";
        if (this.select3 == "USDT" || this.select3 == "USDC") {
          if (this.act_index == 1) {
            u_token_type = `${this.select3}-ERC20`;
          } else if (this.act_index == 2) {
            u_token_type = `${this.select3}-TRC20`;
          } else if (this.act_index == 3) {
            u_token_type = `${this.select3}-BSC20`;
          }
        } else {
          u_token_type = this.select3;
        }

        this.api_data_obj = {
          type: 1,
          token_type: u_token_type,
          value: Number(this.input_v3),
          details: { name: "", address: "", type: "" },
          email: "",
          authCode: "",
        };
      }

      if (this.checked_jmhb) {
        this.Continue_other_btn();
      }

      // 法币
      if (this.checked_jmhb) {
        if (this.api_data_obj.value) {
          sessionStorage.setItem("fb_bz_1", JSON.stringify(this.api_data_obj));
          this.$router.push("/blockchain_w/new_fiat");
        }
      } else {
        // 加密货币
        if (this.api_data_obj.value) {
          sessionStorage.setItem(
            "jmhb_bz_1",
            JSON.stringify(this.api_data_obj)
          );
          this.$router.push("/blockchain_w/new_digital_asset");
        }
      }
    },

    // 加密货币 提币按钮 (转换别的币种)
    Continue_other_btn() {
      let u_token_type = "";
      let u_token_type2 = "";
      if (this.select3 == "USDT" || this.select3 == "USDC") {
        if (this.act_index == 1) {
          u_token_type = `${this.select3}-ERC20`;
          u_token_type2 = `${this.select3}_ERC20`;
        } else if (this.act_index == 2) {
          u_token_type = `${this.select3}-TRC20`;
          u_token_type2 = `${this.select3}_TRC20`;
        } else if (this.act_index == 3) {
          u_token_type = `${this.select3}-BSC20`;
          u_token_type2 = `${this.select3}_BSC20`;
        }
      } else {
        u_token_type = this.select3;
        u_token_type2 = this.select3;
      }
      u_token_type;
      u_token_type2;

      if (this.checked_jmhb) {

        let _this = this;
        debounce(function () {
          crypto_calc({
            type: 2,
            token_type: u_token_type,
            to_token_type: _this.select4,
            value: Number(_this.input_v3),
          }).then((res) => {
            if (res.data.code == 200) {
              _this.is_dab = false;
              _this.input_v4 = res.data.data.total_amount;

              _this.fixed_fee = res.data.data.fixed_fee;
              _this.processing_fee = res.data.data.processing_fee;
              _this.processing_rate = res.data.data.processing_rate;
              _this.total_amount = res.data.data.total_amount;
              localStorage.setItem("data_value", res.data.data.total_amount);
              localStorage.setItem("calc_fixed_fee", res.data.data.fixed_fee);
              localStorage.setItem("calc_processing_fee", res.data.data.processing_fee);
              localStorage.setItem("calc_processing_rate", res.data.data.processing_rate);
            } else {
              _this.is_dab = true;
              _this.input_v4 = "";

              _this.fixed_fee = 0;
              _this.processing_fee = 0;
              _this.processing_rate = 0;
              _this.total_amount = 0;

              _this.message.ismessage("error", res.data.msg);
            }
          });
        }, 1000);

        this.api_data_obj = {
          type: 2,
          token_type: u_token_type,
          to_token_type: this.select4,
          value: Number(this.input_v3),
          // fee:u_fee,
          receive: this.input_v4,
          details: {
            name: "",
            address: "",
            account_number: "",
            beneficiary_name: "",
            swift_code: "",
            intermediary_name: "",
            ntermediary_address: "",
            intermediary_country: "",
            intermediary_swift_code: "",
          },
          purpose: "",
          email: "",
          authCode: "",
        };
      } else {
        // 提成加密货币也调用计算的接口 非200code码提示错误信息
        let _this = this;
        debounce(function () {
          crypto_calc({
            type: 1,
            token_type: u_token_type,
            value: Number(_this.input_v3),
          }).then((res) => {
            if (res.data.code == 200) {
              _this.is_dab = false;

              _this.fixed_fee = res.data.data.fixed_fee;
              _this.processing_fee = res.data.data.processing_fee;
              _this.processing_rate = res.data.data.processing_rate;
              _this.total_amount = res.data.data.total_amount;
              localStorage.setItem("data_value", res.data.data.total_amount);
              localStorage.setItem("calc_fixed_fee", res.data.data.fixed_fee);
              localStorage.setItem("calc_processing_fee", res.data.data.processing_fee);
              localStorage.setItem("calc_processing_rate", res.data.data.processing_rate);
            } else {
              _this.is_dab = true;
              _this.message.ismessage("error", res.data.msg);
            }
          });
        }, 1000);
      }
    },
    // 法币 提币按钮
    continue_fb_btn() {
      if (this.inp1_ratio.balance * 1 <= 0) {
        return this.message.ismessage("error", this.$t("main.text468"));
      }
      if (!this.input_v1) {
        return this.message.ismessage("error", this.$t("main.text469"));
      }

      // x.gte(y) // isGreaterThanOrEqualTo 的简写，是否大于等于  this.input_v3 >= this.inp3_ratio.min_out
      let num1 = new BigNumber(this.input_v1).gte(
        new BigNumber(this.inp1_ratio.min_out)
      );
      if (!num1) {
        return this.message.ismessage(
          "error",
          `${this.$t("main.text470")} ${this.inp1_ratio.min_out}`
        );
      }

      // 相同币种 下拉框未选中
      if (this.checked == false) {
        // 判断是否 美元
        if (this.select1 == "USD") {
          // 三个等级 判断
          let u_rate = "";
          // >=  x.gte(y) // isGreaterThanOrEqualTo 的简写，是否大于等于
          if (
            new BigNumber(this.input_v1).gte(
              new BigNumber(this.inp1_ratio.fee_config.level3.min)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level3.rate;
          } else if (
            new BigNumber(this.input_v1).lt(
              new BigNumber(this.inp1_ratio.fee_config.level2.max)
            ) &&
            new BigNumber(this.input_v1).gte(
              new BigNumber(this.inp1_ratio.fee_config.level2.min)
            )
          ) {
            // <  x.lt(y) // isLessThan 的简写，是否小于
            // >=  x.gte(y) // isGreaterThanOrEqualTo 的简写，是否大于等于
            u_rate = this.inp1_ratio.fee_config.level2.rate;
          } else if (
            new BigNumber(this.input_v1).lt(
              new BigNumber(this.inp1_ratio.fee_config.level1.max)
            )
          ) {
            // <  x.lt(y) // isLessThan 的简写，是否小于
            u_rate = this.inp1_ratio.fee_config.level1.rate;
          }

          let u_fee = new BigNumber(this.input_v1)
            .times(new BigNumber(u_rate))
            .toFixed(this.inp1_ratio.decimal, 0);
          if (u_rate && u_fee) {
            this.f_api_data = {
              type: 2,
              token_type: this.select1,
              to_token_type: this.select1,
              value: Number(this.input_v1),
              fee: u_fee,
              receive: new BigNumber(this.input_v1)
                .minus(new BigNumber(u_fee))
                .toFixed(this.inp1_ratio.decimal, 0),
              details: {
                name: "",
                address: "",
                account_number: "",
                beneficiary_name: "",
                swift_code: "",
                intermediary_name: "",
                ntermediary_address: "",
                intermediary_country: "",
                intermediary_swift_code: "",
              },
              purpose: "",
              email: "",
              authCode: "",
            };
          }
        } else {
          // 不是USD 需要换算
          let u_ket = this.select1 + "USD";
          let hs_usd = this.inp1_ratio.rateConfig[u_ket];
          let u_usd = new BigNumber(this.input_v1)
            .times(new BigNumber(hs_usd))
            .toFixed(this.inp1_ratio.decimal, 0);

          // 三个等级 判断
          let u_rate = "";
          if (
            new BigNumber(u_usd).gte(
              new BigNumber(this.inp1_ratio.fee_config.level3.min)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level3.rate;
          } else if (
            new BigNumber(u_usd).lt(
              new BigNumber(this.inp1_ratio.fee_config.level2.max)
            ) &&
            new BigNumber(u_usd).gte(
              new BigNumber(this.inp1_ratio.fee_config.level2.min)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level2.rate;
          } else if (
            new BigNumber(u_usd).lt(
              new BigNumber(this.inp1_ratio.fee_config.level1.max)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level1.rate;
          }

          let u_fee = new BigNumber(this.input_v1)
            .times(new BigNumber(u_rate))
            .toFixed(this.inp1_ratio.decimal, 0);
          if (u_rate) {
            this.f_api_data = {
              type: 2,
              token_type: this.select1,
              to_token_type: this.select1,
              value: Number(this.input_v1),
              fee: u_fee,
              receive: new BigNumber(this.input_v1)
                .minus(new BigNumber(u_fee))
                .toFixed(this.inp1_ratio.decimal, 0),
              details: {
                name: "",
                address: "",
                account_number: "",
                beneficiary_name: "",
                swift_code: "",
                intermediary_name: "",
                ntermediary_address: "",
                intermediary_country: "",
                intermediary_swift_code: "",
              },
              purpose: "",
              email: "",
              authCode: "",
            };
          }
        }
      } else {
        // 不同币种  下拉框选中
        this.checked_active();
      }

      if (this.f_api_data) {
        sessionStorage.setItem("fb_bz_1", JSON.stringify(this.f_api_data));
        this.$router.push("/blockchain_w/new_fiat");
      }
    },
    // 不同币种  下拉框选中
    checked_active() {
      if (this.checked) {
        // 判断是否 美元
        if (this.select1 == "USD") {
          // 三个等级 判断
          let u_rate = "";
          if (
            new BigNumber(this.input_v1).gte(
              new BigNumber(this.inp1_ratio.fee_config.level3.min)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level3.rate;
          } else if (
            new BigNumber(this.input_v1).lt(
              new BigNumber(this.inp1_ratio.fee_config.level2.max)
            ) &&
            new BigNumber(this.input_v1).gte(
              new BigNumber(this.inp1_ratio.fee_config.level2.min)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level2.rate;
          } else if (
            new BigNumber(this.input_v1).lt(
              new BigNumber(this.inp1_ratio.fee_config.level1.max)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level1.rate;
          }

          let u_fee = new BigNumber(this.input_v1)
            .times(new BigNumber(u_rate))
            .toFixed(this.inp1_ratio.decimal, 0);
          let u_key = this.select1 + this.select2 + "";
          let to2 = this.inp1_ratio.rateConfig[u_key];
          // （提币数量 - 手续费）* 汇率
          let u_receive = new BigNumber(this.input_v1)
            .minus(new BigNumber(u_fee))
            .times(new BigNumber(to2))
            .toFixed(this.inp1_ratio.decimal, 0);

          if (u_receive * 1) {
            this.input_v2 = u_receive * 1;
          } else {
            this.input_v2 = "";
          }

          if (u_rate && u_fee) {
            this.f_api_data = {
              type: 2,
              token_type: this.select1,
              to_token_type: this.select2,
              value: Number(this.input_v1),
              fee: u_fee,
              receive: u_receive,
              details: {
                name: "",
                address: "",
                account_number: "",
                beneficiary_name: "",
                swift_code: "",
                intermediary_name: "",
                ntermediary_address: "",
                intermediary_country: "",
                intermediary_swift_code: "",
              },
              purpose: "",
              email: "",
              authCode: "",
            };
          }
        } else {

          // 不是USD 需要换算
          let u_ket = this.select1 + "USD";
          let hs_usd = this.inp1_ratio.rateConfig[u_ket];
          let u_usd = new BigNumber(this.input_v1)
            .times(new BigNumber(hs_usd))
            .toFixed(this.inp1_ratio.decimal, 0);

          // 三个等级 判断
          let u_rate = "";
          if (
            new BigNumber(u_usd).gte(
              new BigNumber(this.inp1_ratio.fee_config.level3.min)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level3.rate;
          } else if (
            new BigNumber(u_usd).lt(
              new BigNumber(this.inp1_ratio.fee_config.level2.max)
            ) &&
            new BigNumber(u_usd).gte(
              new BigNumber(this.inp1_ratio.fee_config.level2.min)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level2.rate;
          } else if (
            new BigNumber(u_usd).lt(
              new BigNumber(this.inp1_ratio.fee_config.level1.max)
            )
          ) {
            u_rate = this.inp1_ratio.fee_config.level1.rate;
          }

          let u_fee = new BigNumber(this.input_v1)
            .times(new BigNumber(u_rate))
            .toFixed(this.inp1_ratio.decimal, 0);
          // receive 还需要*第一对第二的比率
          let u_key = this.select1 + this.select2 + "";
          let to2 = this.inp1_ratio.rateConfig[u_key];
          // （提币数量 - 手续费）* 汇率
          let u_receive = new BigNumber(this.input_v1)
            .minus(new BigNumber(u_fee))
            .times(new BigNumber(to2))
            .toFixed(this.inp1_ratio.decimal, 0);

          this.input_v2 = u_receive * 1;

          if (u_rate) {
            this.f_api_data = {
              type: 2,
              token_type: this.select1,
              to_token_type: this.select2,
              value: Number(this.input_v1),
              fee: u_fee,
              receive: u_receive,
              details: {
                name: "",
                address: "",
                account_number: "",
                beneficiary_name: "",
                swift_code: "",
                intermediary_name: "",
                ntermediary_address: "",
                intermediary_country: "",
                intermediary_swift_code: "",
              },
              purpose: "",
              email: "",
              authCode: "",
            };
          }
        }
      }
    },

    chechbox_act_fun() {
      if (this.checked && this.input_v1) {
        this.checked_active();
      }
    },
    chechbox_jmhb_fun() {
      if (this.checked_jmhb && this.input_v3) {
        this.Continue_other_btn();
      }
    },
    // 加密货币 转换usdt
    set_key(v) {
      if (v.indexOf("-") != -1) {
        return v.split("-")[0];
      } else {
        return v;
      }
    },
    act_index_fun(v) {
      this.act_index = v;
      if(this.input_v3*1){
        this.Continue_other_btn();
      }
      this.set_fee();
    },
    set_fee() {
      if (this.select3 && this.act_index) {
        let key_str = "";
        if (this.act_index == 1) {
          key_str = "ERC20";
        } else if (this.act_index == 2) {
          key_str = "TRC20";
        } else if (this.act_index == 3) {
          key_str = "BSC20";
        }
        let key_str2 = this.select3 + "_" + key_str;
        if (
          this.data_all &&
          this.data_all[this.select3.toLowerCase()] &&
          this.data_all[this.select3.toLowerCase()].fee_config
        ) {
          this.fee_obj =
            this.data_all[this.select3.toLowerCase()].fee_config[key_str2];
        }
      }
    },

    // 表格
    get_list_table() {
      crypto_record({
        page: this.page,
        limit: this.limit,
        start_date: this.form.time ? this.form.time[0] : "",
        end_date: this.form.time ? this.form.time[1] : "",
        token_type: this.form.token_type,
        amount: "",
        tx_id: this.form.amount,
        account_type: 1,
        status: this.form.status,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page_total = res.data.data.count;
          this.tableData = res.data.data.list;
        }
      });
    },
    reset_btn() {
      this.form.time = "";
      this.form.token_type = "";
      this.form.amount = "";
      this.form.status = "";
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list_table();
    },
    apply_btn() {
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list_table();
    },
    current_change(v) {
      this.page = v;
      this.limit = 10;
      this.get_list_table();
    },
    to_info(tx_id, id, type) {
      sessionStorage.setItem("fiat_info_tx_id", tx_id);
      sessionStorage.setItem("fiat_info_id", id);
      // type: 1加密货币 2法币
      if (type == 2) {
        setTimeout(() => {
          this.$router.push("/blockchain_w/fiat_t_h_info");
        }, 100);
      } else {
        setTimeout(() => {
          this.$router.push("/blockchain_w/digital_t_h_info");
        }, 100);
      }
    },
    download_btn() {
      if (this.page_total <= 0) {
        return this.message.ismessage("error", this.$t("main.text335"));
      }
      crypto_download({
        start_date: this.form.time ? this.form.time[0] : "",
        end_date: this.form.time ? this.form.time[1] : "",
        token_type: this.form.token_type,
        account_type: 1,
        amount: "",
        tx_id: this.form.amount,
        status: this.form.status,
      }).then((res) => {
        const filename =
          res.headers["content-disposition"].split(";")[1].split("=")[1] ||
          "download.xlsx";
        const link = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${filename}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    // ----
  },
};
</script>

<style scoped>
.transfer_p {
  margin-top: 40px;
}
.transfer_p1 {
  display: flex;
  justify-content: space-between;
}
.p2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
}
.p3,
.p3:hover,
.p3:focus.p3:active {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #deb981;
  min-width: 200px;
  border-color: #deb981;
  background: transparent;
}
.user_icon,
.user_icon:hover,
.user_icon:focus,
.user_icon:active {
  width: 16px;
  vertical-align: middle;
  margin-right: 13px;
}
.p4 {
  background: #314b69;
  border-radius: 16px;
  margin-top: 25px;
}
.p4_top {
  border-bottom: 1.5px solid #041e35;
  box-sizing: border-box;
  padding: 28px;
}
.p4_top1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.p4_top2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.6);
}
.p4_main_box {
  box-sizing: border-box;
  padding: 28px;
}
/* --- */
.p4_main {
  display: flex;
  justify-content: space-between;
}
.p4_main1 {
  width: 40%;
}
.p4_main2 {
  width: 16%;
}
/* form */
.zdy_form .el-checkbox,
.zdy_form >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.zdy_form >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #deb981;
  border-color: #deb981;
}
.zdy_form >>> .el-checkbox__inner::after {
  border-color: #041e35;
  top: 4px;
  left: 7px;
}
.zdy_form >>> .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: transparent;
}
.zdy_input >>> .el-input__inner {
  /* width: 224px; */
  height: 68px;
  background: #223c58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input {
  width: 100%;
}
.zdy_input {
  display: flex;
}
.zdy_form >>> .el-form-item__label {
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box {
  /* width: 154px; */
  width: 170px;
  height: 68px;
  background: #041e35;
  border-radius: 0px 8px 8px 0px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.type_box1 {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img {
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3 {
  color: rgba(255, 255, 255, 0.8);
}
.bz_list {
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1 {
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child {
  margin-bottom: 0;
}
.inp_btm_tit {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
.xian {
  width: 100%;
  height: 2px;
  background: #041e35;
  margin-top: 125px;
  position: relative;
}
.sanjiao {
  display: block;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-left: 12px solid #041e35;
  /* border-bottom: 5px solid transparent; */
  position: absolute;
  top: -5px;
  right: 0;
}
.bz_btn,
.bz_btn:hover,
.bz_btn:active,
.bz_btn:focus {
  display: inline-block;
  min-width: 224px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  cursor: pointer;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
  padding: initial;
}
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  cursor: not-allowed;
}

.inp_btm_tit2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 9px;
  display: flex;
  align-items: center;
}
.inp_btm_tit2 img {
  /* width: 13px; */
  width: 23px;
  margin-right: 8px;
}
.btm_margin {
  /* margin-top: 85px; */
  margin-top: 40px;
}
/* ------ */
.inp1 >>> .el-input__inner {
  height: 48px;
  background: #223c58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.inp_box {
  position: relative;
}
.inp2 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  text-align: center;
  color: #deb981;
  box-sizing: border-box;
  padding: 7px 20px;
  border: 1.5px solid #deb981;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  position: absolute;
  right: 8px;
  top: 7px;
  line-height: initial;
  background: #223c58;
}
.inp_box2 >>> .el-form-item__label {
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-checkbox__inner::after {
  border-width: 2px;
}
.margin_left {
  margin-left: 20px;
}
.b_type {
  display: inline-block;
  border: 1.5px solid #041e35;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  padding: 7px 16px;
  box-sizing: border-box;
  margin-right: 8px;
  line-height: initial;
  margin-top: 8px;
}
.b_type_act {
  background: #f1c788;
  color: #fff;
  border-color: #f1c788;
}
</style>

<style scoped>
/* 表格 css */
.t_h1_top {
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: inherit;
  font-weight: 500;
}
.zdy_form >>> .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  color: #deb981;
  border-color: #deb981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
}
.zdy_form .btn_box {
  width: auto;
}
.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  align-items: center;
}
.t_h2_txt1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  color: #deb981;
  border-color: #deb981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  min-width: 120px;
  background: transparent;
}
.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red {
  color: #f35f65;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    margin-top: 40px;
    align-items: flex-start;
  }
}
</style>


<style>
.bz_pop {
  color: #fff;
  font-size: 15px;
  background: #041e35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
</style>

<style scoped>
/* 手机端 */
@media screen and (max-width: 850px) {
  .transfer_p1 {
    flex-direction: column !important;
  }
  .p2 {
    font-size: 12px !important;
    margin-bottom: 10px;
  }
  .p3,
  .p3:hover,
  .p3:focus.p3:active {
    font-size: 12px !important;
    min-width: 165px !important;
    padding: 10px;
  }
  .margin_left {
    margin-left: 0px !important;
    margin-top: 15px;
  }
  .p4_main {
    display: flex;
    flex-direction: column;
  }
  .p4_main1 {
    width: 100% !important;
  }
  .p4_main2 {
    display: none;
  }
  .btn_box_mobile {
    display: flex;
    flex-direction: column;
  }
  .btn_box_mobile .p3 {
    width: max-content;
  }
}
</style>